 <template>
	<el-form class="add_form" status-icon label-position="left" label-width="100px">
		<div class="item">
			<div class="title">基本信息</div>
			<div class="inner">
				<el-table :data="normal_data" :border="true" :stripe="true" size="small">
					<el-table-column label="车型图">
						<template slot-scope="scope">
							<div @click="type_img_choose" class="type_img">
								<img v-if="scope.row.type_img.src" :src="scope.row.type_img.src" class="img">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="车型名称">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.name"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="车长(米)">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.length" type="number"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="车宽(米)">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.width" type="number"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="车高(米)">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.height" type="number"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="额定载重(吨)">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.weight" type="number"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="额载体积(方)">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.volume" type="number"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="起步价(元)">
						<template slot-scope="scope">
							<el-input class="el_input" v-model="scope.row.starting_price" type="number"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="item">
			<div class="title">细分车型 / 主车型后续里程报价</div>
			<div class="inner" style="justify-content: space-between;">
				<div class="meal">
					<el-table :data="meal" :border="true" :stripe="true" size="small">
						<el-table-column label="细分车型名称">
							<template slot-scope="scope">
								<el-input class="el_input" v-model="scope.row.meal_name" placeholder="必填"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="上报监管平台车型名称">
							<template slot-scope="scope">
								<el-cascader class="el_input" v-model="scope.row.logink_truck_type" placeholder="非必填" :options="logink_truck_type" filterable></el-cascader>
							</template>
						</el-table-column>
						<el-table-column label="起步价(元/公里)">
							<template slot-scope="scope">
								<el-input class="el_input" v-model="scope.row.meal_price" placeholder="必填" type="number"></el-input>
							</template>
						</el-table-column>
						
						<!-- 操作行 -->
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click="meal_add">添加</el-button>
								<el-button size="mini" type="text" v-if="scope.$index!=0" @click="meal_del(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="other_price">
					<el-table :data="other_price" :border="true" :stripe="true" size="small">
						<el-table-column label="起始里程(公里)">
							<template slot-scope="scope">
								<el-input class="el_input" v-model="scope.row.start_mileage"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="终止里程(公里)">
							<template slot-scope="scope">
								<el-input class="el_input" v-model="scope.row.end_mileage"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="里程内单价(元/公里)">
							<template slot-scope="scope">
								<el-input class="el_input" v-model="scope.row.mileage_price"></el-input>
							</template>
						</el-table-column>

						
						<!-- 操作行 -->
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click="other_price_add">添加</el-button>
								<el-button size="mini" type="text" v-if="scope.$index!=0" @click="other_price_del(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<div class="bottom_btns">
			<el-button type="primary" @click="add_view_sub">提交</el-button>
		</div>
	</el-form>
</template>

<script>
	export default {
		props:{
			logink_truck_type:Array
		},
		data() {
			return {

				//基本数据
				normal_data:[{
					
					//车型图
					type_img:{
						src: '', //图片地址
						key: '', //图片key
						is_choose: false,
						is_upl: false,
						bucket: 'trucktype',
					},
					
					//车型名称
					name:'',

					//长宽高
					length:'',//长
					width:'',//宽
					height:'',//高

					//载重信息
					weight:'',//额定载重
					volume:'',//额载体积
				}],
				
				//后续历程报价
				other_price:[{
						start_mileage:'',//起始里程
						end_mileage:'',//终止里程
						mileage_price:'',//价格
					}
				],

				//细分车型
				meal:[{
						meal_name:'',//细分车型名称
						logink_truck_type:null,//上报监管平台车型名称
						meal_price:'',//细分车型起步价
					}
				]
			}
		},
		methods:{

			//选择车型图
			type_img_choose(){

				let ctr_obj=this.normal_data[0].type_img

				//选择图片
				this.$my.qiniu.choose_img({
					success: (res) => {
						ctr_obj.src = res.src;
						ctr_obj.is_choose = true;
						ctr_obj.is_upl = false;
					}
				});
			},

			//提交
			add_view_sub(){

				if(!this.normal_data[0].name.trim()){
					this.$my.other.msg({
						type:'warning',
						str:'缺少车型名称'
					});
					return;
				}else this.normal_data[0].name=this.normal_data[0].name.trim();

				if(!this.$my.check.is_num(this.normal_data[0].length)){
					this.$my.other.msg({
						type:'warning',
						str:'缺少车长'
					});
					return;
				}

				if(!this.$my.check.is_num(this.normal_data[0].width)){
					this.$my.other.msg({
						type:'warning',
						str:'缺少车宽'
					});
					return;
				}

				if(!this.$my.check.is_num(this.normal_data[0].height)){
					this.$my.other.msg({
						type:'warning',
						str:'缺少车高'
					});
					return;
				}

				if(!this.$my.check.is_num(this.normal_data[0].weight)){
					this.$my.other.msg({
						type:'warning',
						str:'缺少载重'
					});
					return;
				}

				if(!this.$my.check.is_num(this.normal_data[0].volume)){
					this.$my.other.msg({
						type:'warning',
						str:'缺少额载体积'
					});
					return;
				}

				if(!this.$my.check.is_num(this.normal_data[0].starting_price)){
					this.$my.other.msg({
						type:'warning',
						str:'缺少起步价'
					});
					return;
				}

				let post_data={
					mod:'truck',
					ctr:'truck_type_add_admin',
					name:this.normal_data[0].name,
					length:this.normal_data[0].length,
					width:this.normal_data[0].width,
					height:this.normal_data[0].height,
					weight:this.normal_data[0].weight,
					volume:this.normal_data[0].volume,
					starting_price:this.normal_data[0].starting_price,
					meal:[],
					other_price:[],
				}

				//车型可选项(json)(类似于商品套餐)
				for(var item of this.meal){
					item.meal_name=item.meal_name.trim()
					if(!item.meal_name){
						break;
					}
					if(!this.$my.check.is_num(item.meal_price)){
						break;
					}
					if(item.meal_price<=0){
						break;
					}
					post_data.meal.push({...item})
				}

				//后续里程价格(json)
				for(var item of this.other_price){
					
					if(!this.$my.check.is_num(item.start_mileage)){
						break;
					}
					if(item.start_mileage<=0){
						break;
					}

					if(!this.$my.check.is_num(item.end_mileage)){
						break;
					}
					if(item.end_mileage<=0){
						break;
					}

					if(!this.$my.check.is_num(item.mileage_price)){
						break;
					}
					if(item.mileage_price<=0){
						break;
					}

					post_data.other_price.push({...item})
				}

				if(post_data.meal.length==0){
					this.$my.other.msg({
						type:'warning',
						str:'缺少细分车型'
					});
					return;
				}

				if(post_data.other_price.length==0){
					this.$my.other.msg({
						type:'warning',
						str:'缺少后续里程报价'
					});
					return;
				}

				//上传车型图
				let ctr_obj=this.normal_data[0].type_img
				if(ctr_obj.is_choose){

					//上传
					this.$my.qiniu.upl({
						bucket: ctr_obj.bucket,
						key: ctr_obj.key, //xxxxxx?v=1 或者 null
						file_path: ctr_obj.src,
						callback: (data) => {
							ctr_obj.is_upl = true;
							ctr_obj.key = data.key;
							
							//置入表单
							post_data.img=data.key

							//提交表单
							this.$my.net.req({
								data:post_data,
								callback:(data)=>{
									this.$emit('end_of_sub',{
										is_close:true
									})
								}
							});
						}
					});

				//未上传车型图
				}else{

					//提交表单
					this.$my.net.req({
						data:post_data,
						callback:(data)=>{
							this.$emit('end_of_sub',{
								is_close:true
							})
						}
					});
				}
			},

			//删除细分车型
			meal_del(index){
				this.meal.splice(index,1);
			},

			//添加细分车型
			meal_add(){
				this.meal.push({
					meal_name:'',//细分车型名称
					logink_truck_type:null,//上报监管平台车型名称
					meal_price:'',//细分车型起步价
				});
			},

			//删除后续历程报价
			other_price_del(index){
				this.other_price.splice(index,1);
			},

			//添加后续里程报价
			other_price_add(){
				this.other_price.push({
					start_mileage:'',//起始里程
					end_mileage:'',//终止里程
					mileage_price:'',//价格
				});
			},
		}
	}
</script>

<style lang="scss" scoped>

	//底部提交按钮
	.bottom_btns{
		width: 100%;
		text-align: center;
		position: absolute;
		bottom: 0px;
		left: 0;
		padding: 20px 0;
		border-top: 1px solid #ddd;
	}

	.meal{
		width: 48%;
		height: 380px;
		overflow: auto;
	}
	.other_price{
		width: 48%;
		height: 380px;
		overflow: auto;
	}

	//表单
	.add_form{
		height: calc(100% - 70px);
		.item{

			.title{
				background-color: #eee;
				font-size: 16px;
				font-weight: 600;
				padding: 14px 20px;
			}
			.inner{
				display: flex;
				flex-wrap: wrap;
				padding: 20px 20px;

				.type_img{
					width:100%;
					height:80px;
					line-height: 80px;
					font-size: 50px;
					text-align: center;
					border:1px solid #ccc;
					border-radius:5px;
					cursor:pointer;

					.img{
						max-width:100%;
						max-height:100%;
					}
				}
			}

			.el_input{
				width: 90%;
			}

			.upl_ctr{
				width: 200px;
				height: 120px;
				border: 1px solid #DCDFE6;
				.preview{
					width: 100%;
					height: 100%;
				}
				.upl_btn{
					height: 120px;
					line-height: 120px;
				}
			}

		}
	}
</style>